import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const ApiClientContext = createContext(null);
export const ApiClientProvider = ({ config, children }) => {
    return (_jsx(ApiClientContext.Provider, { value: { config }, children: children }));
};
export const useApiClient = () => {
    const context = useContext(ApiClientContext);
    if (!context) {
        throw new Error('useApiClient must be used within an ApiClientProvider');
    }
    return context;
};
//# sourceMappingURL=ApiClientContext.js.map